import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import AccountBankEditor from './editor';

@modal(
  {
    className: 'partner-register-city-editor-modal',
  },
  true,
)
class AccountBankEditorContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t, editParams, partnerId, cardId } = this.props;

    return (
      <div className="partner-register-city-editor">
        <div className="partner-register-city-editor__header" style={{ paddingBottom: '24px' }}>
          {cardId ? 'Edit' : 'Create'} Bank Account
          {/* {t(`cms.referral.partner.detail.editor.register_city.title`)} */}
          <CloseOutlined
            className="partner-register-city-editor__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>

        <AccountBankEditor
          t={t}
          partnerId={partnerId}
          bankName={editParams.bankName}
          beneficiaryName={editParams.beneficiaryName}
          card={editParams.card}
          cardId={cardId}
          onClose={this.props.handleCloseModal}
        />
      </div>
    );
  }
}

AccountBankEditorContainer.propTypes = {
  t: PropTypes.func.isRequired,
  editParams: PropTypes.object.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

AccountBankEditorContainer.defaultProps = {
  t: () => {},
  editParams: {},
  handleCloseModal: () => {},
};

export default AccountBankEditorContainer;
